import {Inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {
  SecurityMeasureCategory,
  OrganizationalMeasureCategoryCreateRequest,
  OrganizationalMeasureCategoryCreateResponse,
  OrganizationalMeasureCategoryDetails,
  OrganizationalMeasureCategoryUpdateRequest,
  OrganizationalMeasureCategoryUpdateResponse
} from '@ms-organization-entities';
import {CategoryMeasureDependency, PriorityPatchRequest} from '@primatoo-ms-organization';
import {ApiClientConfig} from '../api-client-config';
import {DataProtectionGovernanceService} from '../interface/data-protection-governance-service';
import {ColumnWithLocalization} from "it/primatoo/openapi/api/org/schemas/common/ColumnWithLocalization";

@Injectable({
  providedIn: 'root'
})
export class SecurityMeasureCategoryService extends DataProtectionGovernanceService {
  private readonly endpoint: string;

  constructor(
    @Inject(ApiClientConfig) private config: ApiClientConfig,
    public httpClient: HttpClient
  ) {
    super(httpClient);
    this.endpoint = this.config.endPoint + '/api/org/organizational-measure-categories/';
  }


  setPriority(id: number, request: PriorityPatchRequest): Observable<SecurityMeasureCategory> {
    const url = `${this.endpoint}${id}/priority`;
    return this.httpClient.patch<SecurityMeasureCategory>(url, request);
  }

  public getOrganizationalMeasureCategories(): Observable<SecurityMeasureCategory[]> {
    const url = this.endpoint;
    return this.httpClient.get<SecurityMeasureCategory[]>(url);
  }

  public findUserColumns(): Observable<ColumnWithLocalization[]> {
    const url = this.endpoint + `columns`;
    return this.httpClient.get<ColumnWithLocalization[]>(url);
  }

  // public updateUserColumns(columnsConfigurationUpsertRequest: ColumnsConfigurationUpsertRequest): Observable<void> {
  //   const url = this.endpoint + 'user-columns';
  //   return this.httpClient.post<void>(url, columnsConfigurationUpsertRequest);
  // }

  public getOrganizationalMeasureCategoryById(id: number): Observable<SecurityMeasureCategory> {
    const url = this.endpoint + id + '/';
    return this.httpClient.get<SecurityMeasureCategory>(url);
  }

  public getOrganizationalMeasureCategoryDetails(id: number): Observable<OrganizationalMeasureCategoryDetails> {
    const url = this.endpoint + id + '/details';
    return this.httpClient.get<OrganizationalMeasureCategoryDetails>(url);
  }

  public deleteOrganizationalMeasureCategory(id: number): Observable<SecurityMeasureCategory> {
    const url = this.endpoint + id + '/';
    return this.httpClient.delete<SecurityMeasureCategory>(url);
  }

  public createOrganizationalMeasureCategory(requestBody: OrganizationalMeasureCategoryCreateRequest): Observable<OrganizationalMeasureCategoryCreateResponse> {
    const url = this.endpoint;
    return this.httpClient.post<OrganizationalMeasureCategoryCreateResponse>(url, requestBody);
  }

  public updateOrganizationalMeasureCategory(id: number, requestBody: OrganizationalMeasureCategoryUpdateRequest): Observable<OrganizationalMeasureCategoryUpdateResponse> {
    const url = this.endpoint + id + '/';
    return this.httpClient.put<OrganizationalMeasureCategoryUpdateResponse>(url, requestBody);
  }

  public getDependency(id: number): Observable<CategoryMeasureDependency> {
    const url = this.endpoint + `${id}/dependency`;
    return this.httpClient.get<CategoryMeasureDependency>(url);
  }

  public getEndPointV1(): string {
    return this.endpoint;
  }

  public getGroups(): Observable<string[]> {
    const url = this.endpoint + 'groups/';
    return this.httpClient.get<string[]>(url);
  }
}
